import PatientStepStickyFooterContent from "./PatientStepStickyFooterContent";
export default PatientStepStickyFooterContent;
